import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import en from './en/en.json';
import dt from './dt/dt.json';

export const resources = {
  en: {
    translation: en,
  },
  dt: {
    translation: dt,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});
